import { render, staticRenderFns } from "./uploadFotoEstudante.vue?vue&type=template&id=4b4ffa0c&"
import script from "./uploadFotoEstudante.vue?vue&type=script&lang=js&"
export * from "./uploadFotoEstudante.vue?vue&type=script&lang=js&"
import style0 from "./uploadFotoEstudante.vue?vue&type=style&index=0&id=4b4ffa0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports